import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput, {
  formatLatexPreview,
} from "../../../../components/inputs/FractionInput";

function randInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

export function generateTask() {
  const a = randInt(2, 14);
  const b = randInt(2, 12);
  const c = randInt(2, 10);
  const volume = a * b * c;

  return {
    type: "CuboidVolumeTask",
    data: { a, b, c, volume },
  };
}

export function renderTask({ data }) {
  const { a, b, c } = data;
  return (
    <div style={{ textAlign: "left", lineHeight: 1.6 }}>
      <p>{"Oblicz obj\u0119to\u015b\u0107 prostopad\u0142o\u015bcianu o kraw\u0119dziach:"}</p>
      <BlockMath
        math={`a=${a}\\,\\text{cm},\\quad b=${b}\\,\\text{cm},\\quad c=${c}\\,\\text{cm}`}
      />
    </div>
  );
}

export function renderInput(_task, userAnswer = {}, onChange, disabled) {
  return (
    <FractionInput
      value={userAnswer}
      onChange={onChange}
      disabled={disabled}
      label="V"
      suffixLatex={String.raw`\text{cm}^3`}
      placeholder="np. 120"
    />
  );
}

export function checkAnswer({ data }, userAnswer) {
  const parsed =
    userAnswer && typeof userAnswer === "object" ? userAnswer.parsed : NaN;
  if (!Number.isFinite(parsed)) return { correct: false };
  return { correct: Math.abs(parsed - data.volume) < 0.01 };
}

export function renderAnswer({ data }) {
  return <InlineMath math={`V=${data.volume}\\,\\text{cm}^3`} />;
}

export function renderUserAnswer(userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) {
    return <i>(brak odpowiedzi)</i>;
  }
  return (
    <InlineMath
      math={`${formatLatexPreview(userAnswer.raw, "V")}\\,\\text{cm}^3`}
    />
  );
}

export function renderExplanation({ data }) {
  const { a, b, c, volume } = data;

  return (
    <div style={{ textAlign: "left", lineHeight: 1.7 }}>
      <p>
        <strong>Krok 1:</strong>{" "}
        {"Korzystamy ze wzoru na obj\u0119to\u015b\u0107 prostopad\u0142o\u015bcianu:"}
      </p>
      <BlockMath math={"V=a\\cdot b\\cdot c"} />

      <p>
        <strong>Krok 2:</strong> Podstawiamy dane:
      </p>
      <BlockMath math={`V=${a}\\cdot ${b}\\cdot ${c}`} />
      <BlockMath math={`V=${volume}\\,\\text{cm}^3`} />
    </div>
  );
}
